export const META_TYPE = 'fearGreed';
export const META_VER = 'v1';

export const CMD_FEARGREED_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
